import { render, staticRenderFns } from "./Fortune.vue?vue&type=template&id=a19effd6&scoped=true&"
import script from "./Fortune.vue?vue&type=script&lang=js&"
export * from "./Fortune.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19effd6",
  null
  
)

export default component.exports